import { useMemo } from "react";
import { moduleOptions } from "../data";
// Define which permissions are available for each module based on backend structure
const modulePermissionsConfig = {
    Dashboard: ["View"],
    Nodes: ["View", "Create", "Edit", "Delete"],
    Alarms: ["View", "Acknowledge", "Clear"],
    Insights: ["View"],
    Reports: ["View", "Generate", "Export"],
    Users: ["View", "Create", "Edit", "Delete"],
    AccessPoints: ["View", "Create", "Edit", "Delete"],
    Roles: ["View", "Create", "Edit", "Delete"],
};
export const usePermissionsGrid = ({ roleClaims }) => {
    const getModulePermissions = (moduleName) => {
        return (roleClaims.find((claim) => claim.module === moduleName) || {
            module: moduleName,
            viewPermission: false,
            createPermission: false,
            editPermission: false,
            deletePermission: false,
        });
    };
    const gridRows = useMemo(() => {
        return moduleOptions.filter((m) => m.value !== "Insights").map((module) => {
            const permissions = getModulePermissions(String(module.value));
            const availablePermissions = modulePermissionsConfig[String(module.value)] || [];
            const isDashboard = String(module.value) === "Dashboard";
            const isAccessPoints = String(module.value) === "AccessPoints";
            return {
                id: module.value,
                module: module.label,
                viewPermission: isDashboard || isAccessPoints ? true : permissions.viewPermission,
                editPermission: permissions.editPermission,
                createPermission: permissions.createPermission,
                deletePermission: permissions.deletePermission,
                availablePermissions: availablePermissions,
                hasView: availablePermissions.includes("View"),
                hasCreate: availablePermissions.includes("Create"),
                hasEdit: availablePermissions.includes("Edit"),
                hasDelete: availablePermissions.includes("Delete"),
                hasAcknowledge: availablePermissions.includes("Acknowledge"),
                hasClear: availablePermissions.includes("Clear"),
                hasGenerate: availablePermissions.includes("Generate"),
                hasExport: availablePermissions.includes("Export"),
                isDashboard: isDashboard,
                isAccessPoints: isAccessPoints,
                // hasSettings: availablePermissions.includes("Settings"),
                // hasLogs: availablePermissions.includes("Logs"),
            };
        });
    }, [roleClaims]);
    return {
        gridRows,
        getModulePermissions,
        modulePermissionsConfig,
    };
};
